var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 19.2031C10.3487 18.2211 9.28164 17.1446 8.30986 15.9848C6.85152 14.243 5.11975 11.649 5.11975 9.17708C5.11846 6.59542 6.6731 4.26741 9.05823 3.27939C11.4434 2.29138 14.1888 2.83811 16.0135 4.66445C17.2134 5.85901 17.8856 7.48394 17.8802 9.17708C17.8802 11.649 16.1484 14.243 14.6901 15.9848C13.7183 17.1446 12.6512 18.2211 11.5 19.2031ZM11.5 6.4427C10.5231 6.4427 9.62037 6.96387 9.13192 7.80989C8.64347 8.65591 8.64347 9.69825 9.13192 10.5443C9.62037 11.3903 10.5231 11.9115 11.5 11.9115C13.0101 11.9115 14.2343 10.6872 14.2343 9.17708C14.2343 7.66693 13.0101 6.4427 11.5 6.4427Z",
    fill: "#79819A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.68a155fb70c664bc9db64e635b11df9a.svg";
export { ForwardRef as ReactComponent };